export default __webpack_public_path__ + "static/media/upload-cloud.6b4fa255.svg";